import styles from './invictustest.module.css'

const InvictusTeachercontri = () => {
    return (
        <div>
            {/* teacher contri start */}
            <div className="container">
                <div className={`${styles.teact_contri_wrapper}`}>
                    <div className={`${styles.text_contri}`}>
                        <h3>Our Teacher’s Contribution to Your Success!</h3>
                        <div className={`${styles.m_block}`}><img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/teacher_icon.png" /></div>
                        <h4>1,10,000+</h4>
                        <h6>Students placed in prestigious engineering institutions</h6>
                    </div>
                    <div className={`${styles.d_block}`}><img src="https://dcx0p3on5z8dw.cloudfront.net/Aakash/s3fs-public/inline-images/invictus/teacher_icon.png" /></div>
                </div>
            </div>
            {/* teacher contri end */}
        </div>
    )
}

export default InvictusTeachercontri